import { LightningColorArray, LightningSearchTypeEnum, LightningTabsEnum } from "@/util/cosntants";
import { useMap } from "@vis.gl/react-google-maps";
import React, { useCallback, useEffect, useRef } from "react";

interface ICircleOverlayProps {
    lat: number;
    lng: number;
    radiusKm: number; // 半径，单位：公里
    searchType?: LightningSearchTypeEnum; // 新增的属性
    currentTab: LightningTabsEnum; // 当前选项卡，用于判断是否需要清除圆形区域
    isClear?: boolean
    // 可以添加更多属性，例如颜色、透明度等
    strokeColor?: string;
    strokeOpacity?: number;
    strokeWeight?: number;
    fillColor?: string;
    fillOpacity?: number;
}

const zIndex = 99; // 圆形的 z-index，确保它在其他图层之上

const CircleOverlay = (prop: ICircleOverlayProps) => {
    const {
        lat,
        lng,
        radiusKm,
        strokeColor = LightningColorArray.Green,
        strokeOpacity = 1,
        strokeWeight = 3,
        searchType,
        currentTab,
        isClear
    } = prop;

    const map = useMap(); // 获取地图实例
    const circleRef = useRef<google.maps.Circle | null>(null); // 用于存储圆形实例


    // 定义填充颜色，根据 selectType 动态计算
    const getFillColor = useCallback(():[string | undefined,number] => {
        const tmpFillColor = searchType === LightningSearchTypeEnum.ALLCLEAR ? LightningColorArray.AllClear : undefined; // 如果不是 'Risk'，则不设置 fillColor
        const tmpFillOpacity = searchType === LightningSearchTypeEnum.ALLCLEAR ? 0.3 : 0;
        return [tmpFillColor,tmpFillOpacity];
    }, [searchType]);

    useEffect(() => {
        if (!map || lat === 0 || lng === 0) {
            if(lat === 0 && lng === 0){
                if (circleRef.current) {
                    circleRef.current.setMap(null);
                    circleRef.current = null;
                    console.log("移除圆形区域");
                }
            }
            console.warn("Map instance not available for CircleOverlay.");
            return;
        }

        if(currentTab !== LightningTabsEnum.LOCATION){
            if (circleRef.current) {
                circleRef.current.setMap(null);
                circleRef.current = null;
                console.log("移除圆形区域");
            }
            return; // 如果当前选项卡不是 LOCATION，则不绘制圆形区域
        }

        // 将公里转换为米，Google Maps Circle API 需要米作为半径单位
        const radiusMeters = radiusKm * 1000;

        // 如果 circleRef.current 已经存在，则更新其属性
        const [fillColor,fillOpacity] = getFillColor();

        // 如果 circleRef.current 已经存在，则更新其属性
        if (circleRef.current) {
            circleRef.current.setOptions({
                center: { lat, lng },
                radius: radiusMeters,
                strokeColor,
                strokeOpacity,
                strokeWeight,
                fillColor,
                fillOpacity,
                zIndex: zIndex
            });
            console.log(`更新圆形区域：中心点 {lat: ${lat}, lng: ${lng}}, 半径 ${radiusKm} 公里`);
        } else {
            // 否则，创建新的圆形实例
            const circle = new google.maps.Circle({
                strokeColor,
                strokeOpacity,
                strokeWeight,
                fillColor,
                fillOpacity,
                map,
                center: { lat, lng },
                radius: radiusMeters,
                zIndex: 99
            });
            circleRef.current = circle;
            console.log(`创建圆形区域：中心点 {lat: ${lat}, lng: ${lng}}, 半径 ${radiusKm} 公里`);
        }

        // 清理函数：在组件卸载或依赖项变化时移除圆形
        return () => {
            if (circleRef.current) {
                circleRef.current.setMap(null);
                circleRef.current = null;
                console.log("移除圆形区域");
            }
        };
    }, [map, lat, lng, radiusKm,getFillColor,currentTab]); // 依赖项

    useEffect(()=>{
        if(isClear){
            if (circleRef.current) {
                circleRef.current.setMap(null);
                circleRef.current = null;
                console.log("移除圆形区域");
            }
        }
    },[isClear]);


    console.log("circle map zoom ",map?.getZoom());
    console.log("circle lat ",lat);
    console.log("circle lng ",lng);
    console.log("circle radiusKm ",radiusKm);

    return null; // 这个组件不渲染任何 DOM 元素
};

export default CircleOverlay;